const STORAGE_KEY = 'viewPeriod';

let cachedDefaultViewPeriod: any;

export const viewPeriod = {
  get(): any | null {
    const data = localStorage.getItem(STORAGE_KEY);
    if (data === null) {
      return data;
    }
    const parsedData = JSON.parse(data);
    return parsedData.map((date: string | null) =>
      date === null ? null : new Date(date)
    );
  },
  set(dateRange: any): void {
    const data = JSON.stringify(dateRange);
    localStorage.setItem(STORAGE_KEY, data);
  },
  getDefault(): any {
    if (!cachedDefaultViewPeriod) {
      const TODAY = new Date();
      const DAY_OF_WEEK = TODAY.getDay(); // 0 = vasárnap, 1 = hétfő, ..., 6 = szombat

      // Számoljuk ki az aktuális hét hétfőjét (vagy ha ma hétfő van, akkor azt a napot)
      const START_DATE = new Date(TODAY);
      const offset = (DAY_OF_WEEK === 0 ? -6 : 1 - DAY_OF_WEEK); // ha vasárnap van, -6 nap
      START_DATE.setDate(TODAY.getDate() + offset);

      // Következő hétfő = start + 7 nap
      const END_DATE = new Date(START_DATE);
      END_DATE.setDate(START_DATE.getDate() + 7);

      cachedDefaultViewPeriod = [START_DATE, END_DATE];
    }
    return cachedDefaultViewPeriod;
  }
};
